export default __webpack_public_path__ + "static/media/921110.05f7bbd6.svg";